import {
  compose,
  withHandlers,
  withProps,
  withPropsOnChange,
  withState,
} from 'recompose';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import withCost from './withCost';
import { getHasBarberLoyaltyProgram } from '../../barbers/selectors';
import { getIsFormValid, getPromoCode, getGiftCardBalance } from '../selectors';
import { fetchPromo, resetPromo, resetPromoError, removePromoFromReservation } from '../actions';
import { getGiftCardEnabled, getHasPromotionsEnabled, getHasShopLoyaltyProgram } from '../../shops/selectors';
import withRouteParameters from './withRouteParameters';

const mapStateToProps = (state, ownProps) => ({
  isValid: state.reservation.getIn(['promo', 'isValid']),
  error: state.reservation.getIn(['promo', 'error']),
  isFetching: state.reservation.getIn(['promo', 'isFetching']),
  validatedPromoCode: getPromoCode(state),
  inputDisabled: state.reservation.getIn(['promo', 'isValid']),
  formValid: getIsFormValid(state),
  giftCardEnabled: getGiftCardEnabled(state, ownProps.shopRoute),
  hasGiftCardBalance: getGiftCardBalance(state) !== null,
  hasPromotions: (getHasPromotionsEnabled(state, ownProps.shopRoute)),
  hasLoyaltyProgram: (
    getHasBarberLoyaltyProgram(state, ownProps.barberRoute) ||
    getHasShopLoyaltyProgram(state, ownProps.shopRoute)
  ),
  validationNote: state.reservation.getIn(['promo', 'validationNote']),
});

const mapDispatchToProps = {
  fetchPromo,
  resetPromo,
  resetPromoError,
  removePromoFromReservation,
};

export default compose(
  withRouteParameters,
  withCost,
  connect(mapStateToProps, mapDispatchToProps),
  withState('promoCode', 'setPromoCode', ''),
  withPropsOnChange(['validatedPromoCode'], (props) => {
    if (!props.validatedPromoCode) {
      props.setPromoCode();
    }
  }),
  withPropsOnChange(
    (prevProps, nextProps) => !prevProps.error && nextProps.error,
    (props) => {
      props.setPromoCode('');
      props.removePromoFromReservation();
    },
  ),
  withHandlers({
    onChange: props => (e) => {
      props.setPromoCode(e.target.value.toUpperCase());
      if (props.error) {
        props.resetPromoError();
      }
    },
    handleSubmit: props => (e) => {
      e.preventDefault();
      if (isEmpty(props.promoCode)) return;
      if (props.isValid) {
        props.resetPromo();
        return;
      }
      props.fetchPromo(props.promoCode);
    },
  }),
  withProps(props => ({
    submitEnabled: props.promoCode && (props.isValid || props.promoCode !== props.validatedPromoCode),
  })),
);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/ReedemCodeSharedContainer.js